var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-status-container"},[_c('small',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"data-container",class:[
      _vm.status,
      { 'value-processing': _vm.isProcessing },
      { 'value-moving': _vm.isMoving } ]},[_c('h3',[_vm._v(_vm._s(_vm.value)+" "+_vm._s(_vm.unit))])])])}
var staticRenderFns = []

export { render, staticRenderFns }